const Button = ({ primary, onClick, text, className, ...props }) => (
    <button
        className={
            (primary ? 'bg-gradient-to-r from-orange to-pink text-white ' : 'border border-black ') +
            `py-4 rounded-xl block ${className ?? ''}`
        }
        onClick={onClick}
        {...props}
    >
        {text}
    </button>
);

export default Button;
